import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "open", "closed" ]

  initialize() {
    const menuId = this.data.get("menu-id");
    this.menu = document.getElementById(menuId);
  }

  toggle(event) {
    [this.openTarget, this.closedTarget, this.menu].forEach((elem) => {
      elem.classList.toggle('hidden');
      elem.classList.toggle('block');
    });
    event.stopPropagation();
  }
}